import { List } from 'antd';
import styled from 'styled-components';

export const StyledList = styled(List)`
  padding: ${({ theme }) => theme.token.paddingXS}px;

  .list-item {
    padding: 0;
    border: none;
    width: 100%;
    margin: 0;
  }
`;

export const ListItemStyled = styled.div<{
  $isSelected: boolean;
  $itemHeight: number;
}>`
  height: ${({ $itemHeight }) => $itemHeight}px;
  padding: ${({ theme }) => theme.token.paddingXS}px ${({ theme }) => theme.token.padding}px;
  display: flex;
  align-items: center;
  width: 100%;
  margin: ${({ theme }) => theme.token.marginXXS}px ${({ theme }) => theme.token.marginXS}px;
  border-radius: 4px;
  background: ${({ $isSelected, theme: { token } }) =>
    $isSelected ? token.Ecoplant_Compressor.colorBGSelected : 'transparent'};
  color: ${({ theme: { token } }) => token.colorText};
  transition: all 0.2s ease;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.token.colorTextSecondary};
`;
